<template>
  <b-modal
    title="Logs de Pesquisa"
    :visible="visible"
    size="xl"
    hide-footer
    @hide="close"
  >
    <b-table
      :items="formattedLogs"
      :fields="fields"
      :busy="isLoading"
      :style="{ borderTop: 'hidden' }"
      class="lvj-table"
    />
    <div class="d-flex justify-content-center">
      <b-button @click="loadMore">Carregar Mais</b-button>
    </div>
  </b-modal>
</template>

<script>
import http from "../../plugins/http";
export default {
  name: "SearchLog",
  model: {
    prop: "visible",
    event: "close",
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      page: 2,
      logs: [],
      fields: [
        {
          key: "log",
          label: "Pesquisa Solicitada",
        },
        {
          key: "resultado",
          label: "Obteve Resultado",
        },
      ],
    };
  },
  computed: {
    formattedLogs() {
      return this.logs.map((e) => ({
        ...e,
        resultado: e.resultado ? "Sim" : "Não",
      }));
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
      this.initialFetch();
    },

    async initialFetch() {
      this.isLoading = true;
      try {
        const { data } = await http.get("/log/search");
        this.logs = data;
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    },
    async loadMore() {
      this.isLoading = true;
      try {
        const { data } = await http.get(`/log/search?page=${this.page}`);
        this.logs.push(...data);
        this.page++;
      } catch (err) {
        console.log(err);
      }
      this.isLoading = false;
    },
  },
  async created() {
    await this.initialFetch();
  },
};
</script>

<style lang="scss" scoped>
.lvj-table::v-deep tr th:last-child {
  width: 15%;
}
</style>
